import { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import Pagination from "../../components/ui/Pagination";
import RenderTable from "../../components/ui/RenderTable";
import { Chip, pluralize, toQuery } from "../../helpers/general";
import { useCookie } from "../../hooks/useCookie";
import { general } from "../../locales/general";
import apiService from "../../service/apiService";
import { cardStyle } from "../Places/PlacesTable";
import AdminRoute from "../auth/RestrictedRoute";
import AdvertisementTable from "./AdvertisementTable";

const PAGE_SIZE = 10;

export default function Notifications() {
  const [currentPage, setCurrentPage] = useState(1);
  const { token } = useCookie("vToken");

  const endpoint = `publications/all${toQuery({
    page: currentPage,
    limit: PAGE_SIZE,
  })}`;

  const { data, isLoading, isPreviousData, refetch } = useQuery(
    ["getAllPublications", token, currentPage],
    () => apiService.MakeGetRequest(endpoint, token),
    { keepPreviousData: true, enabled: Boolean(token) },
  );

  const total = data?.meta?.totalItems ?? 0;

  return (
    <AdminRoute>
      <section>
        {/* Title + count + add */}
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <div className="d-flex align-items-center gap-2">
            <h5 className="fs-4 fw-bold mb-0">Publications</h5>
            {data && (
              <Chip tone="warning">
                {total} {pluralize("Publication", total)}
              </Chip>
            )}
          </div>

          <Link
            to="/advertisement/new"
            className="btn btn-primary text-white rounded-pill px-4"
          >
            + Ajouter une publication
          </Link>
        </div>

        {/* Table */}
        <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
          <RenderTable
            loading={isLoading || isPreviousData}
            render={() =>
              data?.items?.length > 0 ? (
                <AdvertisementTable
                  publications={data.items as Publication[]}
                  refetch={refetch}
                />
              ) : (
                <p className="text-center text-muted py-5 mb-0">
                  {general.fr.noData}
                </p>
              )
            }
          />
        </div>

        <Pagination
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          siblingCount={1}
          totalCount={data?.meta?.totalPages}
          pageSize={PAGE_SIZE}
        />
      </section>
    </AdminRoute>
  );
}
